import type { Editor as TiptapEditor } from '@tiptap/react';
import { forwardRef, useImperativeHandle } from 'react';

import * as S from './style';

export interface EditorRef {
  focus: () => void;
  getContent: () => string;
}

export interface EditorProps {
  editor: TiptapEditor | null;
}

export const Editor = forwardRef<EditorRef, EditorProps>(({ editor }, ref) => {
  useImperativeHandle<EditorRef, EditorRef>(ref, () => ({
    focus: () => editor?.commands.focus(),
    getContent: () => editor?.getHTML() ?? '',
  }));

  return <S.StyledEditor editor={editor} editable />;
});

Editor.displayName = 'Editor';
